import React, { useCallback } from 'react';
import { Editor, IAllProps } from '@tinymce/tinymce-react';
import { i18n } from 'next-i18next';
import getConfig from 'next/config';

interface TinyMCEEditorProps extends IAllProps {
  id: string;
  initialValue?: string;
  onInit?: () => void;
  placeholder?: string;
  withMedia?: boolean;
  toolbar?: string;
  height?: number;
  onValueChange: (value: string) => void;
  setValidation?: (value: boolean) => void;
}

const TinyMCEEditor: React.FC<TinyMCEEditorProps> = ({
  id,
  initialValue,
  placeholder,
  onValueChange,
  toolbar,
  height,
  withMedia = true,
  onInit,
}) => {
  const defaultToolbar =
    'undo redo | formatselect | fontsize | ' +
    'bold underline italic backcolor  | alignleft aligncenter alignright ' +
    'alignjustify | bullist numlist outdent indent | removeformat';

  const { publicRuntimeConfig } = getConfig();
  const handleEditorChange = useCallback(
    (value: string) => {
      onValueChange(value);
    },
    [onValueChange],
  );

  return (
    <>
      <Editor
        id={id}
        initialValue={initialValue}
        apiKey={publicRuntimeConfig.TINYMCE_API_KEY}
        onEditorChange={handleEditorChange}
        onInit={onInit}
        init={{
          height: height || 527,
          menubar: false,
          language: i18n?.language,
          placeholder,
          invalid_elements: withMedia ? '' : 'img',
          contextmenu: false,
          plugins: ['autolink', 'media', 'lists', 'link', 'image', 'preview', 'searchreplace', 'wordcount'],
          toolbar1: toolbar || defaultToolbar,
          entity_encoding: 'raw',
          branding: false,
          elementpath: false,
          setup: (editor) => {
            editor.on('keydown', (event) => {
              const characterCount = editor.plugins.wordcount.body.getCharacterCount();
              if (characterCount >= 4000 && event.keyCode !== 8) {
                event.preventDefault();
              }
            });
          },
        }}
      />
    </>
  );
};

export default TinyMCEEditor;
